<template>
  <div>
    <p>Ваш код для входа в ИКС</p>
    <ul>
      <li v-for="(leter, index) in getCode"
          :key="index"
      >{{leter}}
      </li>
    </ul>
    <p>{{seconsToRestartCode}} секунд до смены кода</p>

  </div>
</template>

<script>
  let timerNewCode = '';
  let timerSeconds = '';
  let versionTimer = '';
  let tikTakInterval = '';
  import {mapGetters, mapState} from 'vuex';
  export default {
    name: "accesCode",
    data() {
      return {
        seconsToRestartCode: 60,
        tikTakInterval: '*',
        canGetNewCode: true,
        lastTimeLocal: '',
        test: ''
      }
    },
    watch: {
      tikTakInterval: function (val) {
        console.log(val);
      },
    },
    computed: {
      ...mapGetters(['getCode']),
    },
    methods: {
      getNewCodeIteration: function () {
        //обновляем циферки на табло
        this.seconsToRestartCode = 60;

        //проверяем есть ли условия для запроса
        if (localStorage.getItem("Staff_guid") == '' || localStorage.getItem("Staff_guid") == null) {
          clearInterval(this.tikTakInterval);
          this.$store.commit('setView', 'verificationCode');
          console.log('set can true');
          this.canGetNewCode = true;
          return false;
        }
        console.log('before Send')
        this.$myApi.SendRequest({
          action: 'getCode',
          Staff_guid: localStorage.getItem('Staff_guid'),
        }, this, 'getCode', true)
        .then((res) => {
          //обновляем код на табло
          this.$store.commit('hideModal');
          this.$store.commit('setCode', res.Code_x);
          console.log('set can true');
          this.canGetNewCode = true;
        })
        .catch((res) => {
          //смотрим на ошибки, и если не стремная попробуем еще раз.
          console.log('set can true');
          this.canGetNewCode = true;
          try {
            if (res.Error.ErrorMessage == 'Не существует запроса с указанным RequestID') {
              this.getNewCode();
            } else {
              this.$myApi.displayErrors(res, this);
              localStorage.setItem('Staff_guid', '');
              clearInterval(this.tikTakInterval);
              this.$store.commit('setView', 'verificationCode');
            }
          } catch (res) {
            this.seconsToRestartCode = 5;
            let errorMsg = '';
            try {
              console.log(res);
              if (res.message == 'Network Error') {
                errorMsg = 'Нет подключения к интернету'
              } else {
                errorMsg = JSON.stringify(res);
              }
            }
            catch (e) {
              errorMsg = JSON.stringify(e);
            }
            this.$store.commit('setContent', 'Повторный запрос через 5 секунд<br/>Ошибка: ' + errorMsg);
            this.$store.commit('showModal');
          }
        });
      },
      timerUpdate() {

        let nowTimeMarker = new Date().getTime();

        if (this.lastTimeLocal != '') {
          let delta = nowTimeMarker - this.lastTimeLocal;
          if (delta > 1500) {
            this.seconsToRestartCode = 0;
          }
          this.lastTimeLocal = nowTimeMarker;
        } else {
          this.lastTimeLocal = nowTimeMarker;
        }


        //не чего не делать, если запрос еще выполняется
        if (this.canGetNewCode) {
          if (this.seconsToRestartCode > 0) {
            this.seconsToRestartCode = this.seconsToRestartCode - 1;
          } else {
            this.getNewCode();
          }
        }
      },
      getNewCode() {
        //даем отсечку, новым запросам пока этот не выполнился
        this.canGetNewCode = false;
        //чистим старый код от соблазна его ввести
        this.$store.commit('setCode', '    ');
        this.$store.commit('setContent', 'Отправка запроса');
        this.$store.commit('showModal');

        //проверяем версию приложухи, если все ок, то просим новый код
        this.$myApi.checkVersion('access')
          .then(this.getNewCodeIteration)
          .catch((e)=>{
            //если что то пошло не так, например дохлый инет через 5 секунд пробуем снова
            this.canGetNewCode = true;
            this.seconsToRestartCode = 5;
            let errorMsg = '';
            try {
              console.log(e)
              if (e.message == 'Network Error') {
                errorMsg = 'Нет подключения к интернету'
              } else {
                errorMsg = JSON.stringify(e);
              }
            }
            catch (res) {
              errorMsg = JSON.stringify(res);
            }
            this.$store.commit('setContent', 'Повторный запрос через 5 секунд<br/>Ошибка: ' + errorMsg);
            this.$store.commit('showModal');
          });
      },
    },
    mounted() {
      let self = this;
      if (this.tikTakInterval !== '*') {
        clearInterval(this.tikTakInterval);
      }
      if (this.getCode == '    ') {
        this.getNewCode();
      }

      this.tikTakInterval = setInterval(() => {
        // console.log('interval ID ' + this.tikTakInterval);

        self.timerUpdate();
      }, 1000);

    }
  }
</script>

<style scoped>
  ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 9vw;
  }

  li {
    width: 14vw;
    height: 14vw;
    margin: 0 1vw;
    border: 1px solid grey;
    display: flex;
    align-items: center;
    justify-content: center
  }

  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

</style>
